// import React from 'react';
// import { NavLink } from 'react-router-dom';

// const Sidebar = () => {
//   const menuItems = [
//     { icon: '/images/sidebar/dashboard.png', activeIcon: '/images/sidebar/dashboard_white.png', label: 'Dashboard', path: '/dashboard' },
//     { icon: '/images/sidebar/plans.png', activeIcon: '/images/sidebar/plans_white.png', label: 'Plans', path: '/plans' },
//     { icon: '/images/sidebar/premiums.png', activeIcon: '/images/sidebar/premiums_white.svg', label: 'Premiums', path: '/premiums' },
//     { icon: '/images/sidebar/discounts.png', activeIcon: '/images/sidebar/discounts_white.png', label: 'Discounts', path: '/discounts' },
//     { icon: '/images/sidebar/qoues.png', activeIcon: '/images/sidebar/qoues_white.png', label: 'Quotes', path: '/quote-history' },
//   ];

//   return (
//     <div className="bg-custom-gradient text-white w-64 min-h-screen p-4 flex flex-col">
//       <div className="flex justify-center mb-6">
//         <img
//           src="/images/sidebar/sidebar_logo.png"
//           alt="Pacific Logo"
//           className="w-28 h-auto"
//         />
//       </div>

//       <nav>
//         <ul className="space-y-3">
//           <h1 className="text-[#9DAFC4] font-black text-[15px]">MAIN</h1>
//           {menuItems.map((item, index) => (
//             <li key={index}>
//               <NavLink
//                 to={item.path}
//                 className={({ isActive }) =>
//                   `p-2 flex items-center gap-5 font-semibold text-[18px] rounded-lg cursor-pointer ${
//                     isActive ? 'bg-orangeColor text-white' : 'text-[#9DAFC4] hover:text-white'
//                   }`
//                 }
//               >
//                 {({ isActive }) => (
//                   <>
//                     <img
//                       src={isActive ? item.activeIcon : item.icon}
//                       alt={`${item.label} Icon`}
//                       className={`${
//                         item.label === 'Dashboard' ? 'w-4 h-4' : 'w-5 h-5'
//                       }`}
//                     />
//                     {item.label}
//                   </>
//                 )}
//               </NavLink>
//             </li>
//           ))}
//         </ul>
//       </nav>

//       <div className="2xl:mt-40 mt-10">
//         <NavLink
//           to="/logout"
//           className={({ isActive }) =>
//             `flex items-center gap-5 font-bold cursor-pointer p-2 rounded ${
//               isActive ? 'bg-orangeColor text-white' : 'text-[#9DAFC4] hover:text-white'
//             }`
//           }
//         >
//           {({ isActive }) => (
//             <>
//               <img
//                 src={
//                   isActive
//                     ? '/images/sidebar/logout_white.png'
//                     : '/images/sidebar/logout.png'
//                 }
//                 alt="Logout Icon"
//                 className="w-4 h-4"
//               />
//               Logout
//             </>
//           )}
//         </NavLink>
//       </div>
//     </div>
//   );
// };

// export default Sidebar;

import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi"; // Import menu icons

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false); // State for sidebar toggle

  const menuItems = [
    {
      icon: "/images/sidebar/dashboard.png",
      activeIcon: "/images/sidebar/dashboard_white.png",
      label: "Dashboard",
      path: "/dashboard",
    },
    {
      icon: "/images/sidebar/plans.png",
      activeIcon: "/images/sidebar/plans_white.png",
      label: "Plans",
      path: "/plans",
    },
    // { icon: '/images/sidebar/premiums.png', activeIcon: '/images/sidebar/premiums_white.svg', label: 'Premiums', path: '/premiums' },
    // { icon: '/images/sidebar/discounts.png', activeIcon: '/images/sidebar/discounts_white.png', label: 'Discounts', path: '/discounts' },
    {
      icon: "/images/sidebar/qoues.png",
      activeIcon: "/images/sidebar/qoues_white.png",
      label: "Quotes",
      path: "/quote-history",
    },
  ];

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.reload();
  };

  return (
    <div className="z-50 ">
      {/* Menu Button for Mobile */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`md:hidden fixed top-5 left-5 z-50 text-3xl transition-colors duration-300 ${
          isOpen ? "text-white" : "text-fontcolor"
        }`}
      >
        {isOpen ? <FiX /> : <FiMenu />}
      </button>

      {/* Sidebar */}
      <div
        className={`fixed top-0 left-0 h-full bg-custom-gradient text-white  p-4 flex flex-col transition-transform duration-300
          ${
            isOpen ? "translate-x-0" : "-translate-x-full"
          } md:translate-x-0 md:static md:min-h-screen`}
      >
        <div className="flex justify-center mb-6">
          <img
            src="/images/sidebar/sidebar_logo.png"
            alt="Pacific Logo"
            className="w-28 h-auto"
          />
        </div>

        <nav>
          <ul className="space-y-3">
            <h1 className="text-[#9DAFC4] font-black text-[15px]">MAIN</h1>
            {menuItems.map((item, index) => (
              <li key={index}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `p-2 flex items-center gap-5 font-semibold text-[18px] rounded-lg cursor-pointer ${
                      isActive
                        ? "bg-orangeColor text-white"
                        : "text-[#9DAFC4] hover:text-white"
                    }`
                  }
                  onClick={() => setIsOpen(false)} // Close menu on click
                >
                  {({ isActive }) => (
                    <>
                      <img
                        src={isActive ? item.activeIcon : item.icon}
                        alt={`${item.label} Icon`}
                        className={`${
                          item.label === "Dashboard" ? "w-4 h-4" : "w-5 h-5"
                        }`}
                      />
                      {item.label}
                    </>
                  )}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        {/* Logout */}
        <div className="2xl:mt-40 mt-10">
          <NavLink
            to="/logout"
            className={({ isActive }) =>
              `flex items-center gap-5 font-bold cursor-pointer p-2 rounded ${
                isActive
                  ? "bg-orangeColor text-white"
                  : "text-[#9DAFC4] hover:text-white"
              }`
            }
            // onClick={() => setIsOpen(false)} // Close menu on logout
            onClick={handleLogout}
          >
            {({ isActive }) => (
              <>
                <img
                  src={
                    isActive
                      ? "/images/sidebar/logout_white.png"
                      : "/images/sidebar/logout.png"
                  }
                  alt="Logout Icon"
                  className="w-4 h-4"
                />
                Logout
              </>
            )}
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
